<template>
  <div class="">
    <div class="text-white flex-1 col-span-1 border-0 rounded-t-xl overflow-hidden">
      <div class="bg-theme-green px-4 py-2 text-white">
        <div class="flex justify-between items-center">
          <div class="font-bold tracking-wider leading-tight text-2xl mt-0 capitalize">
            {{ form.processor.value ? form.processor.value : 'Add New Terminal'}}
          </div>
          <div class="flex  items-center">
            <!-- <mdicon @click.prevent="clearComponent" size="32" class="close-icon flex justify-end cursor-pointer hover:opacity-60 mb-2 " name="close" /> -->
            <button @click.prevent="addNew()" class="h-10 hover:bg-theme-darkgreen border-0 hover:text-white rounded-md cursor-pointer text-green-400 bg-white py-2 px-4 uppercase ">
              SAVE
            </button>
            <span @click="clearComponent" class="cursor-pointer rounded-md  text-white py-2 pl-1  hover:opacity-70">CLOSE</span>
          </div>
        </div>
      </div>

      <div class="pt-3 bg-[#2B2C32] px-[16px] py-[16px] rounded-lg border-b border-l border-r border-theme-green rounded-t-none">

        <div class="flex xl:flex-row flex-col gap-3 items-start mb-3">
          
            <div class="w-full xl:w-1/2">
              <div :class="'input-wrapper ' + (form.processor.error_type)">
                <label class="text-xs mb-1">Name:</label>
                <select @change="validateFields(['processor'])" v-model="form.processor.value" class="block rounded bg-gray-black w-full">
                   <option disabled value="">--Select--</option>
                  <option value="moneris">Moneris</option>
                  <option value="clover">Clover</option>
                </select>
                <p class="field-error label-text mt-1" v-if="form.processor.error_message" v-text="form.processor.error_message"></p>
              </div>
            </div>

            <div class="w-full xl:w-1/2">
              <div :class="'input-wrapper ' + (form.terminalId.error_type)">
                <label class="text-xs mb-1">Terminal ID:</label>
                <input placeholder="Terminal id"  @keyup="validateFields(['terminalId'])" v-model="form.terminalId.value" class="block rounded bg-gray-black w-full" type="text" />
                <p class="field-error label-text mt-1" v-if="form.terminalId.error_message" v-text="form.terminalId.error_message"></p>
              </div>
            </div>
          </div>

          <div class="flex xl:flex-row flex-col gap-3 items-start mb-3">
            <div class="w-full xl:w-1/2" v-if="form.processor.value==='clover'">
              <div :class="'input-wrapper ' + (form.merchantId.error_type)">
                <label class="text-xs mb-1">Merchant ID:</label>
                <input placeholder="Merchant ID"  @keyup="validateFields(['merchantId'])" v-model="form.merchantId.value" class="block rounded bg-gray-black w-full" type="text" />
                <p class="field-error label-text mt-1" v-if="form.merchantId.error_message" v-text="form.merchantId.error_message"></p>
              </div>
            </div>
      
            <div class="w-full">
              <div class="flex xl:flex-row flex-col gap-3 mb-3">
                  <div class="w-full xl:w-1/2">
                      <label class="text-xs mb-1 mt-0">Status:</label>
                      <label class="flex items-center cursor-pointer xl:mt-2">
                          <input type="checkbox" v-model="form.active" class="hidden peer">
                          <div :class="'relative toggle-bg  border-2  h-6 w-11 rounded-full ' + (form.active ? 'bg-theme-green border-theme-green' : 'bg-[#F53333] border-[#F53333]')"></div>
                          <span class="ml-2 text-white text-sm font-medium uppercase" :class="form.active ? 'text-theme-green' : 'text-[#F53333]'">{{form.active ? 'ON' : 'OFF'}}</span>
                      </label>

                  </div>
               
              </div>
            </div>

            <!-- <div class="w-full xl:w-1/2">
              <label class="text-xs mb-1 mt-0">Status:</label>
                <label class="flex items-center cursor-pointer xl:mt-2">
                <input type="checkbox" v-model="form.active" class="hidden peer">
                <div :class="'relative toggle-bg  border-2  h-6 w-11 rounded-full ' + (form.active ? 'bg-theme-green border-theme-green' : 'bg-[#F53333] border-[#F53333]')"></div>
                <span class="ml-2 text-white text-sm font-medium uppercase" :class="form.active ? 'text-theme-green' : 'text-[#F53333]'">{{form.active ? 'ON' : 'OFF'}}</span>
              </label>
            </div> -->

          </div>
        </div>
    </div>
  </div>
</template>


<script lang="ts">
import {defineComponent, ref} from "vue"
import { mapGetters, mapActions, mapMutations } from "vuex";
import LocationPaymentProcessorApis from "@/controllers/LocationPaymentProcessorApis";
import { useSnackbar } from "vue3-snackbar";
import Helpers from '@/helpers';

export default defineComponent({
  name: "LocationPosAdd",
  components: {
   
  },
  setup() {
    const snackbar = useSnackbar();
    const form = ref({
      processor: {
        value: 'moneris',
        error_type: '',
        error_message: '',
        validations: ['required'],
      },
      merchantId: {
        value: '', //E7JT323858QX1
        error_type: '',
        error_message: '',
        validations: ['required'],
      },
      terminalId: {
        value: '', // 3ERGK6HHS1MWG
        error_type: '',
        error_message: '',
        validations: ['required'],
      },
      active: false,
    });


    return {
      form,
      snackbar,
    };
  },
  props:{
    clearComponent: {
      type: Function,
      required: true,
    },
  },

  watch:{
    
    // terminalId cannot have whitespaces
    'form.terminalId.value'(val){
      if(val) {
        // val = val.toLowerCase();
        val = val.replaceAll(/\s/g,'').trim();
        this.form.terminalId.value = val;
      } else {
        this.form.terminalId.value = '';
      }
    },
    // merchantId cannot have whitespaces
    'form.merchantId.value'(val){
      if(val) {
        // val = val.toLowerCase();
        val = val.replaceAll(/\s/g,'').trim();
        this.form.merchantId.value = val;
      } else {
        this.form.merchantId.value = '';
      }
    },

   
  },

  computed: {
   
      ...mapGetters({
          vg_selectedLocation: 'location/selected'
      }),
  },


  mounted() {
   
  },
 
  methods: {

    
     /**
     * Validation captures
     */
    async validateFields(fields) {
      let res = await Helpers.validateFormFields(this.form, fields);
      // capture the fields
      this.form = res.data;
      return res.error ? false : true;
    },


    /**
     * Add 
     */
    async addNew() {
      let validate = false
      if(this.form.processor.value==='clover'){
        validate = await this.validateFields(['processor', 'merchantId', 'terminalId']);
      }else{
        validate = await this.validateFields(['processor', 'terminalId']);
      }
      if(!validate) {
        return ;
      }
      this.va_spinner(true);
      let data = Helpers.getFormKeyValue(this.form)
      if(this.form.processor.value==='moneris'){
        delete data['merchantId']
      }
      let res = await LocationPaymentProcessorApis.create(data);
      this.va_spinner(false);
        this.snackbar.add({
        type: 'info',
        text: res.status == 201 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
        duration: 3000,
      })
      if(res.status == 201 ) {
        this.clearComponent();
        this.emitter.emit("refresh-location-payment-processor-list", true);
      }
    },


    ...mapActions({
      va_spinner: 'spinner/setSpinner',
    })
  },
});

</script>